import { ForecastParamCode } from 'pleinchamp-api-client';
import { Text } from '@components/Text/Text.component';
import { getMetricWording, metricsWording } from '@meteo/business/forecastParamCodes.utils';
import { MetricsHelpIconButton } from '@meteo/components/MetricsHelpIconButton/MetricsHelpIconButton.component';
import { Breakpoint, useBreakpoint, useIsBreakpointDown } from '@styles/breakpoints';

interface Props {
  forecastParam: ForecastParamCode;
  is15Days?: boolean;
  is36h?: boolean;
  isPro?: boolean;
}

function RowTitle({ forecastParam, is15Days, is36h, isPro }: Props) {
  let descKey: MetricWordingType = 'descHour';
  const isSmartphone = useIsBreakpointDown(Breakpoint.m);
  const breakPoint = useBreakpoint();

  let classname;

  if (!isPro && breakPoint === Breakpoint.m) {
    classname = 'tablet-th-width';
  }

  if (is15Days) {
    descKey = 'desc15d';
  }

  if (is36h) {
    descKey = 'desc36h';
  }

  const description = getMetricWording(forecastParam, descKey);

  return (
    <div className="flex align-center">
      <Text className={classname} tag="div" variant={isSmartphone ? 'h5' : 'tag'}>
        {metricsWording[forecastParam].title}
      </Text>
      {description && (
        <MetricsHelpIconButton title={metricsWording[forecastParam].title}>{description}</MetricsHelpIconButton>
      )}
    </div>
  );
}

export { RowTitle };
